module.exports = __webpack_public_path__ + "static/media/manager-r-8.7091bd16.png";